import axios from 'axios';

const api = axios.create({
  baseURL: 'https://kprocessos-old-server.kintelligence.com.br:3348'
  //baseURL: 'http://192.168.1.23:3348'
});

export default api;